import { genericClientErrorMessageKey, genericErrorMessage } from '~constants/Constants';
import { validateAddUserErrorType } from './RampPgApiSdk';

export const userErrors = [
    'user.wait',
    'user.signup.social_profile_already_connected',
    'user.signup.already_connected_provider'
];

export const BAD_REQUEST_ERROR_CODE = 'user.signup.bad_request';
// eslint-disable-next-line @typescript-eslint/quotes
export const PROVIDER_CACHE_MISSING_MESSAGE = "{'provider' => 'cache missing'}";
// eslint-disable-next-line @typescript-eslint/quotes
export const EMAIL_NOT_VERIFIED = "{'pcEmailAddress' => 'not verified'}";
// eslint-disable-next-line @typescript-eslint/quotes
export const EMAIL_NOT_VALID = "{'emailAddress' => 'invalid format'}";

const isCacheMissingError = (errorCode: string, errorMessage: string) => {
    return errorCode === BAD_REQUEST_ERROR_CODE && errorMessage === PROVIDER_CACHE_MISSING_MESSAGE;
};

const isEmailNotVerifiedError = (errorCode: string, errorMessage: string) => {
    return errorCode === BAD_REQUEST_ERROR_CODE && errorMessage === EMAIL_NOT_VERIFIED;
};

const isEmailNotValidError = (errorCode: string, errorMessage: string) => {
    return errorCode === BAD_REQUEST_ERROR_CODE && errorMessage === EMAIL_NOT_VALID;
};

export const getValidateAddUserError = (
    code: string,
    message: string
): validateAddUserErrorType => {
    return isCacheMissingError(code, message) ? genericClientErrorMessageKey : genericErrorMessage;
};

export const isExpectedUserError = (errorCode: string, options: { errorMessage: string }) => {
    return (
        userErrors.some((x) => x === errorCode) ||
        isCacheMissingError(errorCode, options.errorMessage) ||
        isEmailNotVerifiedError(errorCode, options.errorMessage) ||
        isEmailNotValidError(errorCode, options.errorMessage)
    );
};
